import React from "react";
import { Box } from "@mui/system";
import addIconCircle from "../../assets/images/addIconCircle.svg";
import { Typography } from "@mui/material";

const ImageInput: React.FC = () => {
  return (
    <React.Fragment>
      <Box
        sx={{
          width: { xs: "30px", sm: "30px", md: "40px", xl: "65px" },
          height: { xs: "30px", sm: "30px", md: "40px", xl: "65px" },
          backgroundImage: `url(
                         ${addIconCircle}
                        )`,
          margin: "auto",
          marginTop: { xs: "30px", sm: "30px", md: "50px", xl: "58px" },
          backgroundSize: "cover",
        }}
      />
      <Typography
        sx={{
          letterSpacing: "0.36px",
          color: "#2685f8",
          opacity: 1,
          fontFamily: "Avenir",
          fontSize: { xs: "10px", sm: "12px", md: "14px", xl: "18px" },
          lineHeight: {
            xs: "20px",
            sm: "22px",
            md: "25px",
          },
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        Choose file or take photo or drag here
      </Typography>
    </React.Fragment>
  );
};

export default ImageInput;
